// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___iOxf","left":"styles_left__yjyBZ","desktopActions":"styles_desktopActions__1v50T","title":"styles_title__1atQz"};